import PropTypes from 'prop-types';
import { Alert, AlertTitle, Stack } from '@mui/material';

export const TypeError = {
  error: 'error',
  warning: 'warning',
  info: 'info',
  success: 'success',
};

export default function AlertComponent({ severity, title, content }) {
  return (
    <Stack sx={{ width: '100%', marginTop: '20px' }} spacing={2}>
      <Alert severity={severity}>
        <AlertTitle>{title}</AlertTitle>
        {content}
      </Alert>
    </Stack>
  );
}

AlertComponent.propTypes = {
  severity: PropTypes.oneOfType([
    TypeError.error,
    TypeError.info,
    TypeError.success,
    TypeError.warning,
  ]).isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.oneOf([PropTypes.string, PropTypes.node]).isRequired,
};
